// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + chunkId + "." + "3ba7e684e061c77fb1f7" + ".js";
};